// extracted by mini-css-extract-plugin
module.exports = {"leaderboardFirst":"e_gf","leaderboardSecond":"e_hf"};